import React, { useState, useEffect } from 'react';
import '../Styles/DappChild.css';
import TokenMenu from './TokenMenu.js';
import AmountMenu from './AmountMenu.js';
import { ethers } from "ethers";

const ERC20 = ({ blockchainInfo, setData, setAreFieldsValid, setShowPrimaryButton }) => {
    const [tokenAddress, setTokenAddress] = useState('');
    const [amount, setAmount] = useState('');
    const [recipientAddress, setRecipientAddress] = useState('');
    const [currentoken, setCurrentoken] = useState(null);
    const tokenOptions = blockchainInfo.supportedTokens || [];
    const [tokenAddressError, setTokenAddressError] = useState('');
    const [recipientAddressError, setRecipientAddressError] = useState('');
    const [tokenDecimals, setTokenDecimals] = useState(18); // default to 18

    const alphanumericRegex = /^[a-zA-Z0-9]{0,42}$/;
    const amountOptions = [0.0001, 0.001, 0.01, 0.1, 1, 10, 100];




    // validate fields
    const validateAllFields = () => {
        const isValid = tokenAddress && !tokenAddressError && amount && recipientAddress && !recipientAddressError;
        setAreFieldsValid(isValid); // Update the parent's state
        console.log(isValid)
        if (isValid == true) {
            const data = {
              tokenAddress,
              amount,
              recipientAddress,
              tokenDecimals
            };
            setShowPrimaryButton(true)
            setData(data); // Only send if fields are valid
          }

        return isValid;
    };

    // Call this whenever there's a change that could affect field validity
    useEffect(() => {
        validateAllFields();
    }, [tokenAddress, tokenAddressError, amount, recipientAddress, recipientAddressError]);

    const handleTokenDecimalsChange = (e) => {
        const decimalsAux = e.target.value
        setTokenDecimals(decimalsAux);
        // Check if entered address matches any in tokenOptions
        const matchingToken = tokenOptions.find(token => token.decimals === decimalsAux);
        setCurrentoken(matchingToken || null);  // Reset to null if no match found
    };

    const handleAmountSelection = (selectedAmount) => {
        setAmount(selectedAmount);
    };

    const handleTokenSelection = (selectedTokenObj) => {
        console.log("Selected token:", selectedTokenObj);
        setCurrentoken(selectedTokenObj);
        setTokenAddress(selectedTokenObj.address); // Set the token address
        setTokenDecimals(selectedTokenObj.decimals)
        setTokenAddressError('');  // Clear the error message
    };

    function validEVMAddress(_address) {
        return ethers.isAddress(_address)
    }

    const handleTokenAddressChange = (e) => {
        const enteredAddress = e.target.value.trim();

        // Check if the input is alphanumeric and its length is <= 42
        if (alphanumericRegex.test(enteredAddress)) {
            setTokenAddress(enteredAddress);

            // Validate as user types
            const errorMessage = validateAddress(enteredAddress);
            setTokenAddressError(errorMessage);

            // Check if entered address matches any in tokenOptions
            const matchingToken = tokenOptions.find(token => token.address === enteredAddress);
            setCurrentoken(matchingToken || null);  // Reset to null if no match found
        }
        validateAllFields();
    };

    const handleRecipientAddressChange = (e) => {
        const enteredAddress = e.target.value.trim();

        // Check if the input is alphanumeric and its length is <= 42
        if (alphanumericRegex.test(enteredAddress)) {
            setRecipientAddress(enteredAddress);

            // Validate as user types
            const errorMessage = validateAddress(enteredAddress);
            setRecipientAddressError(errorMessage);
        }
        validateAllFields();
    };

    const validateAddress = (address) => {
        if (address.length == 0) {
            return 'Input EVM address'
        }
        if (!validEVMAddress(address)) {
            return 'Invalid EVM address';
        }
        return ''; // No error
    };

    const handleTokenAddressBlur = () => {
        validateAddress(tokenAddress);
    };

    const handleRecipientAddressBlur = () => {
        validateAddress(recipientAddress);
    };


    const closeMenu = () => {
        setCurrentoken(null);
    };

    const placeholderText = tokenOptions.length > 0 ? "Select Token" : "Automated Tokens coming soon! 🚀";

    return (
        <div className="dapp-child">

            <div className="menu">
                <TokenMenu
                    options={tokenOptions}
                    placeholder={placeholderText}
                    onSelect={handleTokenSelection}
                    closeMenu={closeMenu}
                    selectedToken={currentoken} // Add this prop
                />
            </div>

            <div className="input-group">
                <div className="token-label-group">
                    <label htmlFor="tokenAddress">Or manually input Token Address</label>
                    <label htmlFor="tokenDecimals" className="token-decimals-label">Decimals</label>
                </div>
                <div className="token-input-group">
                    <input
                        type="text"
                        id="tokenAddress"
                        value={tokenAddress}
                        onChange={handleTokenAddressChange}
                        onBlur={handleTokenAddressBlur}
                        placeholder="Token Address"
                        spellCheck="false"
                    />
                    <input
                        type="number"
                        id="tokenDecimals"
                        value={tokenDecimals}
                        onChange={handleTokenDecimalsChange}
                        min="0"
                        max="18"
                        className="token-decimals-input"
                    />
                </div>
                {tokenAddressError && <div style={{ color: 'red' }}>{tokenAddressError}</div>}
            </div>

            <div className="input-group">
                <label htmlFor="amount">Amount</label>
                <AmountMenu
                    options={amountOptions}
                    placeholder="Select Amount"
                    onSelect={handleAmountSelection}
                    selectedToken={amount} // Use the same prop name for simplicity
                />
            </div>

            <div className="input-group">
                <label htmlFor="recipientAddress">Recipient Address</label>
                <input
                    type="text"
                    id="recipientAddress"
                    value={recipientAddress}
                    onChange={handleRecipientAddressChange}
                    onBlur={handleRecipientAddressBlur} // Add onBlur handler
                    placeholder="Recipient Address"
                    spellCheck="false"
                />
                {recipientAddressError && <div style={{ color: 'red' }}>{recipientAddressError}</div>}
            </div>
        </div>
    );
}

export default ERC20;